import type {CardProps} from '@chakra-ui/react';
import {forwardRef, Card as BaseCard} from '@chakra-ui/react';

import {useCardStyleConfig} from '../../theme-config';

export const Card = forwardRef<CardProps, 'div'>((props, ref) => {
  const style = useCardStyleConfig(`container`, props);
  return <BaseCard {...style} {...props} ref={ref} />;
});
